import { useVuex } from '@issue-detail/utils/useVuex';
import { computed } from '@vue/composition-api';
import { ActionStore } from './action';
import { ShareStore } from './share';
import { ProjectStore } from './project';

const AllPermissions = [
  'edit:issue',
  'create:comment',
  'create:issue',
  'integration'
] as const;
type Permission = (typeof AllPermissions)[number];

export const usePermission = (
  action: ActionStore,
  share: ShareStore,
  project: ProjectStore
) => {
  const vuex = useVuex();

  const role = computed(() => project.currentProject.value?.projectRole);

  const permissions = computed<readonly Permission[]>(() => {
    if (
      project.projectRoles.value.some((r) =>
        [
          'organizationOwner',
          'organizationAdmin',
          'projectOwner',
          'projectAdmin'
        ].includes(r.roleCode)
      )
    ) {
      return AllPermissions;
    }

    if (project.currentProject.value) {
      if (role.value === 'innerCollaborator') {
        return ['create:comment', 'create:issue'];
      }
      return AllPermissions;
    }
    return [];
  });
  const hasPermission = (permission: Permission) => {
    return permissions.value.includes(permission);
  };

  return { permissions, hasPermission };
};

export type PermissionStore = ReturnType<typeof usePermission>;
